export default __webpack_public_path__ + "static/media/lynk_laptop.1506f20d.png";